import { render, staticRenderFns } from "./TempAccountPrint.vue?vue&type=template&id=cad346aa"
import script from "./TempAccountPrint.vue?vue&type=script&lang=ts"
export * from "./TempAccountPrint.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports